import React from 'react';
import { SeatAssignment, SeatConfig } from '../types';
import { generateQRCode } from '../utils/qrcode';

interface LotteryResultProps {
  assignment: SeatAssignment;
  config: SeatConfig;
}

const LotteryResult: React.FC<LotteryResultProps> = ({ assignment, config }) => {
  const [qrCodeUrl, setQrCodeUrl] = React.useState<string | null>(null);
  
  React.useEffect(() => {
    const loadQRCode = async () => {
      try {
        const url = await generateQRCode(assignment.seatNumber);
        setQrCodeUrl(url);
      } catch (error) {
        console.error('QRコードの生成に失敗しました:', error);
      }
    };
    
    loadQRCode();
  }, [assignment.seatNumber]);
  
  return (
    <div className="lottery-result">
      <h2>抽選結果</h2>
      
      <div className="user-info">
        <div className="user-name">{assignment.name} さん</div>
      </div>
      
      <div className="seat-info">
        <div className="seat-info-item">
          <span className="label">席番号:</span>
          <span className="value">{assignment.seatNumber}</span>
        </div>
      </div>
      
      {qrCodeUrl && (
        <div className="qrcode-container">
          <p>この画面を保存するか、QRコードを控えておいてください</p>
          <img 
            src={qrCodeUrl} 
            alt="席QRコード" 
            className="qrcode-image" 
          />
        </div>
      )}
      
      <p className="note">
        ※席に着く際は、席に設置されているQRコードと一致することを確認してください。
      </p>
    </div>
  );
};

export default LotteryResult; 